import React from "react";
import styled from "styled-components";
import profile from "../img/contact-profile.jpg";
import { FaFacebookF } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { GrInstagram } from "react-icons/gr";
import { BsWhatsapp } from "react-icons/bs";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import textlogo from "../img/logo-text.png";
import { useStateContext } from "../global-context/useGlobalContext";

const Contact = () => {
  const isMobile = useMediaQuery({ maxWidth: 500 });
  const iconSize = isMobile ? 35 : 50;
  const { language } = useStateContext();
  return (
    <ContactWrapper>
      <ContactImage
        initial={{ y: -250, scale: 0, opacity: 0 }}
        animate={{
          y: 0,
          scale: 1,
          opacity: 1,
        }}
        transition={{
          delay: 1,
          duration: 1.5,
          type: "spring",
          stiffness: 100,
        }}
      >
        <img
          className="profile"
          src={profile}
          alt="Profile"
        />
        <h2>
          <span>Jules</span>, Marine <br />& Robert
        </h2>
        <a
          href="https://goo.gl/maps/HeUuFYomqstnXya7A"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h3>
            <img
              className="logo"
              src={textlogo}
              alt="logo"
            />{" "}
            <br />
            {language ? "30 rue Levasseur" : "30 Levasseur street"} <br />
            35800 Dinard, <br />
            France
          </h3>
        </a>
      </ContactImage>

      <Socials>
        <h1>
          <span>Web Design</span>
        </h1>
        <motion.a
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          href="mailto: robert@jcesardesign.com"
        >
          {" "}
          <MdOutlineEmail
            className="icons"
            size={iconSize}
          />
          <h2>robert@jcesardesign.com</h2>
        </motion.a>
        <h1>
          <span>{language ? "Graphisme" : "Graphic Designer"}</span>
        </h1>
        <motion.a
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          href="mailto: marine@jcesardesign.com"
        >
          {" "}
          <MdOutlineEmail
            className="icons"
            size={iconSize}
          />
          <h2>marine@jcesardesign.com</h2>
        </motion.a>
        <div className="line"></div>
        <motion.a
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.9 }}
          href="tel:+33781028463"
        >
          <BsWhatsapp
            size={iconSize}
            className="icons"
          />
          <h2>+33 7 81 02 84 63</h2>
        </motion.a>
        <motion.a
          href="https://www.facebook.com/jcesardesign"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <FaFacebookF
            className="icons"
            size={iconSize}
          />{" "}
          <h2>@j.cesardesign</h2>
        </motion.a>

        <motion.a
          href="https://www.instagram.com/j.cesardesign/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.7 }}
        >
          <GrInstagram
            className="icons"
            size={iconSize}
          />
          <h2>@j.cesardesign</h2>
        </motion.a>
      </Socials>
    </ContactWrapper>
  );
};

export default Contact;

const ContactWrapper = styled.section`
  padding: 12vh 10rem;
  min-height: 100vh;
  width: 100%;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  color: white;
  position: relative;
  @media (min-width: 950px) {
    flex-direction: row;
  }
`;
const ContactImage = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  h2,
  h3 {
    margin-top: 0.5rem;
    @media (max-width: 476px) {
      margin-top: 1.5rem;
    }
  }
  .profile {
    height: 40vh;
    border-radius: 50%;
    @media (max-width: 476px) {
      height: 30vh;
    }
  }
  .logo {
    height: 1.8vh;
  }
`;
const Socials = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  margin-top: 5vh;
  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
  }
  h1 {
    padding: 0 2.5rem;
    padding-top: 0.5rem;
  }
  .icons {
    margin: 0rem 2.5rem;

    cursor: pointer;
  }
  h2:hover {
    color: #f9cc0b;
  }
  .line {
    border-top: 1px solid #f9cc0b;
    width: 20vw;
    margin-left: 2.5rem;
  }
`;
